import { MenuEntry } from '@src/menu-entry.js';

export default MenuEntry.create()
    .setTitle('Pickwagen befüllen')
    .setRoute('fill-picking-cart_show');
